<script lang="ts">
	import { Grid } from '$lib/components/organisms/Layout';
	import { useCountdown } from '$lib/utils/countdown-store';
  import classnames from 'classnames';
  import { onMount, setContext } from 'svelte';
  import { writable } from 'svelte/store';

  export let stickTo: 'header' | 'tabs' = 'header';
  export let triggerHideStickyFilters: HTMLElement | null = null;

  const countdownStore = useCountdown();
  const displayPromoLabel = countdownStore.displayLabel;

  let hideStickyFilters = writable(false);
  let y = 0;
  let lastY = 0;
  let timer = null;

  setContext('FILTERS', {
    hideStickyFilters,
  });

  let navbarHeight: number;

  onMount(() => {
    navbarHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--navbar-height'));
  });

  const checkHideStickyFilters = (y: number) => {
    if (triggerHideStickyFilters === null || window.matchMedia('(max-width: 767px)').matches) {
      return;
    }
    if (y < triggerHideStickyFilters.offsetTop - navbarHeight ? navbarHeight : 0) {
      return;
    }
    let dy = y - lastY;
    lastY = y;

    if (dy > 0) {
      if ($hideStickyFilters !== true && timer === null) {
        // if scroll down
        timer = setTimeout(() => {
          timer = null;
          $hideStickyFilters = true;
        }, 500);
      }
    } else {
      // if scroll up
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
      $hideStickyFilters = false;
    }
  };

  $: checkHideStickyFilters(y);
</script>

<svelte:window bind:scrollY={y} />

<section
  class={classnames('sticky-filters', $$props.class, {
    'v-stick-tabs': stickTo === 'tabs',
    hide: $hideStickyFilters,
    stickToPromoLabel: $displayPromoLabel,
  })}
>
  <Grid noGrid>
    <slot />
  </Grid>
</section>

<style type="text/scss" lang="scss" scoped>
  .sticky-filters {
    @apply sticky z-sticky-element;
    @apply bg-white;
    @apply py-4 md:py-6;
    @apply shadow-fake-bottom-border;
    @apply duration-300;
    top: calc(var(--navbar-height) - 1px);
    transition: top 0.5s ease-out;

    &.v-stick-tabs {
      top: calc(var(--navbar-height) + var(--tabs-height) - 1px);
    }

    &.hide {
      top: calc(var(--navbar-height) - 180px);

      &.v-stick-tabs {
        top: calc(var(--navbar-height) + var(--tabs-height) - 180px);
      }
    }
  }

  .sticky-filters.stickToPromoLabel {
    top: calc(var(--navbar-height) + var(--promo-height) - 1px);

    &.v-stick-tabs {
      top: calc(var(--navbar-height) + var(--tabs-height) + var(--promo-height) - 1px);
    }

    &.hide {
      top: -calc(var(--navbar-height) + var(--promo-height) - 1px);

      &.v-stick-tabs {
        top: -calc(var(--navbar-height) + var(--tabs-height) + var(--promo-height) - 1px);
      }
    }
  }
</style>
